import TabsWrapperComponent from "./TabsWrapperComponent";

export default TabsWrapperComponent;
